import JsonView from 'react18-json-view';
import { useState, useEffect, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa';
import { useJob } from '../../state';
import { colors, headerHeight } from '../../constants';
import { Run } from '../run';
import { LeftNav } from '../nav';
import { Loading } from '../loading';
import { PillButtons } from '../input';
import { Args, Progress, ItemsTable, Cost, Artifacts } from '../job';
import { Copy } from '../copy';
import { styles } from '../../constants';
import { Timer } from './Timer';
import { VisitResults } from './VisitResults';
import { VisitsList } from './VisitsList';
import { UrlsList } from './UrlsList';
import { RunAgainButton } from './RunAgainButton';
import { NagToPay } from '../level';
import { isActive } from './shared';
import { SummaryTitle } from '../title';
import 'react18-json-view/src/style.css';

const VisitJob = ({ job, slim }) => {
  const pattern = job?.params?.pattern || '';

  return (
    <div>
      <VisitResults job={job} />
    </div>
  );
};

const CrawlJob = ({ job, slim }) => {
  const pattern = job?.params?.pattern || '';

  return (
    <div>
      <UrlsList urls={job?.results?.hits || []} job={job} />
      <br />
      <VisitsList job={job} />
    </div>
  );
};

const ExtractJob = ({ job, slim }) => {
  return (
    <div>
      <ItemsTable jobId={job.id} />
      <br />
      <VisitsList job={job} />
    </div>
  );
};

const ScrapeJob = ({ job, slim }) => {
  return (
    <div>
      <ItemsTable jobId={job.id} />
      <br />
      <UrlsList urls={job?.results?.hits || []} job={job} />
      <br />
      <VisitsList job={job} />
    </div>
  );
};

const JsonJob = ({ job }) => (
  <div>
    <pre>{JSON.stringify(job, null, 2)}</pre>
  </div>
);

export const Inner = ({ job, loading, slim }) => {
  const [tab, setTab] = useState('results');
  const navigate = useNavigate();

  useEffect(() => {
    if (job?.method == 'agent' && job?.id) {
      navigate(`/agents/${job.id}`, { replace: true });
    }
  }, [job, navigate]);

  const summaryObject = useMemo(
    () =>
      job?.method == 'agent'
        ? job?.params?.prompt
        : {
            method: job?.method,
            urls: job?.params?.urls,
            url: job?.params?.url,
            query: job?.params?.query,
            pattern: job?.params?.pattern,
            template: job?.params?.template,
          },
    [job?.method, job?.params],
  );

  if (loading || !job?.method) {
    return <Loading />;
  }

  const innerFn = {
    visit: VisitJob,
    crawl: CrawlJob,
    extract: ExtractJob,
    scrape: ScrapeJob,
  }[job?.method];

  const inner = (innerFn || JsonJob)({ job, slim, loading });
  // const inner = (JsonJob)({ job, slim, loading });

  const headerNode = (
    <div style={styles.stickyHeader}>
      <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
        {!job && <Loading size="xs" />}
        {isActive(job) && <Loading size="xs" />}
        {job && job?.state == 'completed' && (
          <div
            style={{
              color: colors.green,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <FaCheckCircle />
          </div>
        )}
        {job && (
          <div>
            <b>
              {job?.method || 'job'} {job.jobId}
            </b>
          </div>
        )}
        {job && <div>- {job?.state}</div>}
      </div>
    </div>
  );

  const argsNode = (
    <>
      <Args job={job} onRunAgain={() => setTab('results')} />
    </>
  );

  const costNode = (
    <>
      <Cost job={job} showPercent />
    </>
  );

  const timerNode = (
    <>
      <Timer timer={job.timer} />
    </>
  );

  const jsonNode = (
    <>
      <JsonView src={job} />
    </>
  );

  const choices = [
    ['results', 'Results'],
    ['args', 'Arguments'],
    ['jobs', 'Execution'],
    ['cost', 'Cost'],
    // ['artifacts', 'Artifacts'],
    ...(job.timer ? [['timer', 'Timer']] : []),
    ['json', 'JSON'],
  ];

  const childJobs = job?.children?.jobs || job?.children || [];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <SummaryTitle summaryKey={job?.id && `jobId:${job.id}`} object={summaryObject} fallback={`${job?.method} Job`} />
      <div style={{ position: 'sticky', top: 6 + headerHeight, zIndex: 100 }}>
        <NagToPay />
      </div>

      {!slim && headerNode}

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        {!slim && <PillButtons value={tab} onChange={setTab} choices={choices} />}
        {!slim && <RunAgainButton job={job} small grayFlat />}
      </div>

      {/*tab == 'results' && <Progress job={job} slim />*/}
      {tab == 'results' && inner}

      {tab == 'args' && argsNode}

      {tab == 'jobs' && childJobs.length == 0 && <div>No child jobs</div>}
      {tab == 'jobs' && childJobs.length > 0 && <Progress job={job} />}

      {tab == 'cost' && costNode}
      {tab == 'artifacts' && artifactsNode}

      {tab == 'timer' && timerNode}

      {tab == 'json' && jsonNode}

      {/*
      <pre>JOB:{JSON.stringify(job, null, 2)}</pre>
       */}
    </div>
  );
};

// export const Job = ({ id, job, slim }) => {
export const Job = ({ id }) => {
  const { loading, job } = useJob(id);

  return (
    <div>
      <Inner job={job} loading={!job && loading} />
    </div>
  );
};
// <div>job_.id: {''+job_?.id}</div>
// <Inner job={job || job_} loading={!job && loading} slim={slim} />
